import { render, staticRenderFns } from "./QuillEdtor.vue?vue&type=template&id=47585e1e"
import script from "./QuillEdtor.vue?vue&type=script&lang=js"
export * from "./QuillEdtor.vue?vue&type=script&lang=js"
import style0 from "./QuillEdtor.vue?vue&type=style&index=0&id=47585e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports